const Favorite = () => {
  return (
    <div>
      <h3>This is Fav component</h3>
    </div>
  );
};

export default Favorite;
